// extracted by mini-css-extract-plugin
export default {"layer":"feature-layer_layer__RLnO+","loading":"feature-layer_loading__9Z9of","background":"feature-layer_background__Yo+57"};